import { ProfileActions } from '~/actions/profile/action'
import { TranslationService } from '~/services/Translation'
import { NewFeatureActions } from '~/actions/newFeature/action'

export default defineNuxtRouteMiddleware(async (to) => {
	if (import.meta.server) return

	const nuxtApp = useNuxtApp()
	TranslationService.getInstance(nuxtApp.$i18n)
	const profile = await ProfileActions.getProfile()
	if (!profile) return
	const hasToCompleteProfile: boolean = ProfileActions.hasToCompleteProfile(profile)
	if (hasToCompleteProfile) NewFeatureActions.openProfileWizard(to.name as string)
})
